// ** Trash Icons Data

export const trashIcons = {
	trash: {
		viewBox: "0 0 448 512",
		variants: {
			regular: {
				"data-prefix": "far",
				"data-icon": "trash",
				source: "https://fontawesome.com/icons/trash",
				license: "https://fontawesome.com/license",
				path: "M432 80h-82.4l-34-56.7A48 48 0 0 0 274.4 0H173.6a48 48 0 0 0-41.2 23.3L98.4 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16l21.2 339a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM173.6 48h100.8l19.2 32H154.4zm173.3 416H101.11l-21-336h287.8z",
			},
			solid: {
				"data-prefix": "fas",
				"data-icon": "trash",
				source: "https://fontawesome.com/icons/trash",
				license: "https://fontawesome.com/license",
				path: "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z",
			},
		},
	},
};
